import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

interface Props {
  checked: boolean;
  onChange: () => void;
}

const ViewDeletedCheckbox: React.FC<Props> = ({ checked, onChange }) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={onChange} />}
      label="View deleted configurations"
    />
  );
};

export default ViewDeletedCheckbox;
